var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoneyBag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#FFF5D9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57_1856)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.66 18.75H28.34L29.7817 17.5967C30.2725 17.205 30.4558 16.5692 30.2483 15.9758C30.0408 15.3825 29.5017 15 28.875 15H21.125C20.4983 15 19.9592 15.3833 19.7517 15.9758C19.5442 16.5683 19.7275 17.205 20.2175 17.5958L21.66 18.75Z",
    fill: "#FFBB38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4542 20H21.5458C19.27 22.2342 17.5 26.1542 17.5 29.375C17.5 32.1742 18.9817 35 22.2917 35H27.9167C30.7442 35 32.5 32.8442 32.5 29.375C32.5 26.1542 30.73 22.2342 28.4542 20ZM24.6833 26.875H25.3167C26.2908 26.875 27.0833 27.6675 27.0833 28.6417C27.0833 29.5175 26.4517 30.2383 25.625 30.385V31.0408C25.625 31.3858 25.345 31.6658 25 31.6658C24.655 31.6658 24.375 31.3858 24.375 31.0408V30.4167H23.5417C23.1967 30.4167 22.9167 30.1367 22.9167 29.7917C22.9167 29.4467 23.1967 29.1667 23.5417 29.1667H25.3167C25.6017 29.1667 25.8333 28.935 25.8333 28.65C25.8333 28.3567 25.6017 28.125 25.3167 28.125H24.6833C23.7092 28.125 22.9167 27.3325 22.9167 26.3583C22.9167 25.4825 23.5483 24.7617 24.375 24.615V23.9583C24.375 23.6133 24.655 23.3333 25 23.3333C25.345 23.3333 25.625 23.6133 25.625 23.9583V24.5833H26.4583C26.8033 24.5833 27.0833 24.8633 27.0833 25.2083C27.0833 25.5533 26.8033 25.8333 26.4583 25.8333H24.6833C24.3983 25.8333 24.1667 26.065 24.1667 26.35C24.1667 26.6433 24.3983 26.875 24.6833 26.875Z",
    fill: "#FFBB38"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_1856"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(15 15)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyBag);
export default __webpack_public_path__ + "static/media/money-bag.9deb5289.svg";
export { ForwardRef as ReactComponent };